import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the contact to confirm. */
const contactToDeleteSignal = createSignal<number | null>(null);

export const openContactToDelete = (contactId: number): void => {
	contactToDeleteSignal.value = contactId;
};

export const closeContactToDelete = (): void => {
	contactToDeleteSignal.value = null;
};

export default contactToDeleteSignal;
